export default (title, body) => {
  return new Notification(title, { body })
}
